import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_06752ca1 from 'nuxt_plugin_plugin_06752ca1' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_pluginsdynamic7567e1f4_10ddd10b from 'nuxt_plugin_pluginsdynamic7567e1f4_10ddd10b' // Source: ./plugins.dynamic.7567e1f4.js (mode: 'all')
import nuxt_plugin_vlazyload_897ace36 from 'nuxt_plugin_vlazyload_897ace36' // Source: ./v-lazy-load.js (mode: 'all')
import nuxt_plugin_pluginutils_35e8bc38 from 'nuxt_plugin_pluginutils_35e8bc38' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_f2a973a2 from 'nuxt_plugin_pluginrouting_f2a973a2' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_7993eba0 from 'nuxt_plugin_pluginmain_7993eba0' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_vsanitize_39ff2f3e from 'nuxt_plugin_vsanitize_39ff2f3e' // Source: ./v-sanitize.js (mode: 'all')
import nuxt_plugin_recaptcha_58a0c7b4 from 'nuxt_plugin_recaptcha_58a0c7b4' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_clipboard_2297f117 from 'nuxt_plugin_clipboard_2297f117' // Source: ./clipboard.js (mode: 'client')
import nuxt_plugin_axios_45848137 from 'nuxt_plugin_axios_45848137' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_1fdad2df from 'nuxt_plugin_cookieuniversalnuxt_1fdad2df' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_gtm_9f5bac66 from 'nuxt_plugin_gtm_9f5bac66' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_deviceplugin_26821c7c from 'nuxt_plugin_deviceplugin_26821c7c' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_elementui_72a9ed1c from 'nuxt_plugin_elementui_72a9ed1c' // Source: ../plugins/element-ui.js (mode: 'all')
import nuxt_plugin_daisoui_2ab2214a from 'nuxt_plugin_daisoui_2ab2214a' // Source: ../plugins/daiso-ui.js (mode: 'client')
import nuxt_plugin_validation_07995594 from 'nuxt_plugin_validation_07995594' // Source: ../plugins/common/validation/validation.js (mode: 'all')
import nuxt_plugin_vuexhelper_7179a606 from 'nuxt_plugin_vuexhelper_7179a606' // Source: ../plugins/common/vuex/vuex-helper.js (mode: 'all')
import nuxt_plugin_persistedStateclient_3b127e9c from 'nuxt_plugin_persistedStateclient_3b127e9c' // Source: ../plugins/persistedState.client.js (mode: 'client')
import nuxt_plugin_tuigridclient_05051286 from 'nuxt_plugin_tuigridclient_05051286' // Source: ../plugins/common/tui-grid-client (mode: 'client')
import nuxt_plugin_axiosbuilder_287671a0 from 'nuxt_plugin_axiosbuilder_287671a0' // Source: ../plugins/axios/axios-builder.js (mode: 'all')
import nuxt_plugin_axiosbuildercache_9984496a from 'nuxt_plugin_axiosbuildercache_9984496a' // Source: ../plugins/axios/axios-builder-cache.js (mode: 'all')
import nuxt_plugin_axiosbuilderpostcache_6b71e76c from 'nuxt_plugin_axiosbuilderpostcache_6b71e76c' // Source: ../plugins/axios/axios-builder-post-cache.js (mode: 'all')
import nuxt_plugin_quilleditor_13127b74 from 'nuxt_plugin_quilleditor_13127b74' // Source: ../plugins/common/quill-editor.js (mode: 'client')
import nuxt_plugin_lodash_3538f289 from 'nuxt_plugin_lodash_3538f289' // Source: ../plugins/lodash (mode: 'all')
import nuxt_plugin_axiosserver_51445a30 from 'nuxt_plugin_axiosserver_51445a30' // Source: ../plugins/axios/axios-server.js (mode: 'all')
import nuxt_plugin_axiosdefaults_d30747cc from 'nuxt_plugin_axiosdefaults_d30747cc' // Source: ../plugins/axios-defaults.js (mode: 'all')
import nuxt_plugin_index_a3af4526 from 'nuxt_plugin_index_a3af4526' // Source: ../plugins/filters/index.js (mode: 'client')
import nuxt_plugin_swiper_076f49ea from 'nuxt_plugin_swiper_076f49ea' // Source: ../plugins/swiper.js (mode: 'client')
import nuxt_plugin_vcalendar_55bbb5ae from 'nuxt_plugin_vcalendar_55bbb5ae' // Source: ../plugins/v-calendar.js (mode: 'client')
import nuxt_plugin_videoplayer_cd2faf62 from 'nuxt_plugin_videoplayer_cd2faf62' // Source: ../plugins/videoplayer.js (mode: 'client')
import nuxt_plugin_globalcomponent_209c3683 from 'nuxt_plugin_globalcomponent_209c3683' // Source: ../plugins/common/global-component (mode: 'all')
import nuxt_plugin_kakao_25921bca from 'nuxt_plugin_kakao_25921bca' // Source: ../plugins/kakao.js (mode: 'client')
import nuxt_plugin_airbridge_e2bb1b8c from 'nuxt_plugin_airbridge_e2bb1b8c' // Source: ../plugins/airbridge.js (mode: 'client')
import nuxt_plugin_vueqrcode_035b36ae from 'nuxt_plugin_vueqrcode_035b36ae' // Source: ../plugins/vue-qrcode.js (mode: 'client')
import nuxt_plugin_groobeeResponse_8c404216 from 'nuxt_plugin_groobeeResponse_8c404216' // Source: ../plugins/groobeeResponse.js (mode: 'client')
import nuxt_plugin_route_192d86f8 from 'nuxt_plugin_route_192d86f8' // Source: ../plugins/route.js (mode: 'client')
import nuxt_plugin_commonMsgbox_0c37c434 from 'nuxt_plugin_commonMsgbox_0c37c434' // Source: ../plugins/common/commonMsgbox.js (mode: 'client')
import nuxt_plugin_vuestyledcomponents_c7c73b56 from 'nuxt_plugin_vuestyledcomponents_c7c73b56' // Source: ../plugins/vue-styled-components (mode: 'client')
import nuxt_plugin_initzzimclient_a40e072e from 'nuxt_plugin_initzzimclient_a40e072e' // Source: ../plugins/init-zzim.client.js (mode: 'client')
import nuxt_plugin_initancclient_771e4c2d from 'nuxt_plugin_initancclient_771e4c2d' // Source: ../plugins/init-anc.client.js (mode: 'client')
import nuxt_plugin_initbrandzzimclient_62ffc62f from 'nuxt_plugin_initbrandzzimclient_62ffc62f' // Source: ../plugins/init-brand-zzim.client.js (mode: 'client')
import nuxt_plugin_blux_34356b98 from 'nuxt_plugin_blux_34356b98' // Source: ../plugins/blux.js (mode: 'client')
import nuxt_plugin_clicktrackerclient_7a1445db from 'nuxt_plugin_clicktrackerclient_7a1445db' // Source: ../plugins/click-tracker.client.js (mode: 'client')
import nuxt_plugin_jsonld_593ee954 from 'nuxt_plugin_jsonld_593ee954' // Source: ../plugins/jsonld (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"다이소몰","htmlAttrs":{"lang":"ko"},"meta":[{"hid":"description","name":"description","content":"다이소몰은 생활용품, 주방, 인테리어, 문구, 뷰티, 식품 등 다양한 카테고리의 상품을 합리적인 가격에 제공하는 온라인 쇼핑몰입니다."},{"charset":"utf-8"},{"name":"facebook-domain-verification","content":"ojplb4r7wf4r80ozugsw93m850w4zp"},{"hid":"og:title","property":"og:title","content":"다이소몰"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:url","property":"og:url","content":"https:\u002F\u002Fwww.daisomall.co.kr"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fcdn.daisomall.co.kr\u002Ffile\u002FCM\u002Fdaisologo_1.91-1.png"},{"hid":"og:site_name","property":"og:site_name","content":"다이소몰"},{"hid":"og:locale","property":"og:locale","content":"ko_KR"},{"hid":"og:description","property":"og:description","content":"다이소몰은 생활용품, 주방, 인테리어, 문구, 뷰티, 식품 등 다양한 카테고리의 상품을 합리적인 가격에 제공하는 온라인 쇼핑몰입니다."}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"hid":"cms-common-css","id":"cms-common-css","rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.daisomall.co.kr\u002FCMS_CSS\u002FCMS.css"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fgh\u002Forioncactus\u002Fpretendard@v1.3.9\u002Fdist\u002Fweb\u002Fvariable\u002Fpretendardvariable.min.css","crossorigin":"anonymous","as":"style"}],"script":[{"hid":"whatap-browser-agent","innerHTML":"(function(w, h, _a, t, a, b) {\n    w = w[a] = w[a] || {\n      config: {\n        projectAccessKey: \"x2eogo2qqtmlr-x6rkckgs2i4q2p-x280v3n882ul0k\",\n        pcode: 59,\n        sampleRate: 100,\n        sessionReplaySampleRate: 100,\n        sessionReplayMaskAllTexts: false,\n        sessionReplayMaskAllInputs: false,\n        ignoreStatusZero: true,\n        proxyBaseUrl: \"https:\u002F\u002Fwhatap-browser.daisomall.co.kr\u002F59\u002F\",\n      },\n    };\n    a = h.createElement(_a);\n    a.async = 1;\n    a.src = t;\n    t = h.getElementsByTagName(_a)[0];\n    t.parentNode.insertBefore(a, t);\n  })(window, document, 'script', 'https:\u002F\u002Fprdm.daisomall.co.kr\u002Fwhatap\u002Fwhatap-browser-agent.js', 'WhatapBrowserAgent', '');"},{"type":"application\u002Fld+json","innerHTML":"{\"@context\":\"https:\u002F\u002Fschema.org\",\"@type\":\"WebSite\",\"name\":\"다이소몰\",\"alternateName\":\"DAISO Mall\",\"url\":\"https:\u002F\u002Fwww.daisomall.co.kr\",\"potentialAction\":{\"@type\":\"SearchAction\",\"target\":\"https:\u002F\u002Fwww.daisomall.co.kr\u002Fds\u002Fdst\u002FSCR_DST_0015?searchTerm={search_term_string}\",\"query-input\":\"required name=search_term_string\"}}"},{"type":"application\u002Fld+json","innerHTML":"{\"@context\":\"https:\u002F\u002Fschema.org\",\"@type\":\"Organization\",\"name\":\"다이소몰\",\"alternateName\":\"DAISO Mall\",\"description\":\"균일가 생활용품 전문점 다이소의 공식 온라인 쇼핑몰입니다. 생활용품, 주방, 인테리어, 문구, 뷰티, 식품 등 다양한 카테고리의 상품을 합리적인 가격에 제공합니다.\",\"url\":\"https:\u002F\u002Fwww.daisomall.co.kr\",\"logo\":\"https:\u002F\u002Fcdn.daisomall.co.kr\u002Ffile\u002FCM\u002Fdaisologo_1.91-1.png\",\"contactPoint\":{\"@type\":\"ContactPoint\",\"telephone\":\"1599-2211\",\"contactType\":\"customer service\",\"availableLanguage\":\"Korean\"},\"sameAs\":[\"https:\u002F\u002Fwww.instagram.com\u002Fdaisolife\u002F\",\"https:\u002F\u002Fwww.youtube.com\u002Fchannel\u002FUChz7dY8O1jTD8bXGJ8JgXEA\",\"https:\u002F\u002Fblog.naver.com\u002Fdaisoblog\",\"https:\u002F\u002Fwww.facebook.com\u002Fdaisolife\"]}"},{"src":"https:\u002F\u002Fdevelopers.kakao.com\u002Fsdk\u002Fjs\u002Fkakao.js"},{"src":"https:\u002F\u002Fcenterflow.ai\u002Fcdn\u002Fcenterflow.js?20241127","mode":"client"},{"src":"https:\u002F\u002Fconnect.facebook.net\u002Fko_KR\u002Fsdk.js#xfbml=1&version=v17.0"},{"src":"https:\u002F\u002Fdevelopers.band.us\u002Fjs\u002Fshare\u002Fband-button.js?v=07082023"},{"src":"https:\u002F\u002Fwww.line-website.com\u002Fsocial-plugins\u002Fjs\u002Fthirdparty\u002Floader.min.js"},{"src":"\u002F\u002Fcdn.toss.im\u002Fcert\u002Fv1"},{"src":"\u002Fjs\u002Fui-script.js"},{"src":"https:\u002F\u002Funpkg.com\u002Faxios\u002Fdist\u002Faxios.min.js"},{"innerHTML":"\n                (function(a,i,u,e,o) {\n                  a[u]=a[u]||function(){(a[u].q=a[u].q||[]).push(arguments)};\n                  })(window, document, \"groobee\");\n                  groobee(\"serviceKey\", \"ace531b9f5954a96960faa1db76378d6\");groobee(\"siteType\", \"custom\");groobee(\"isSPA\", \"true\");"},{"src":"https:\u002F\u002Fstatic.groobee.io\u002Fdist\u002Fg2\u002Fgroobee.init.min.js","charset":"utf-8"},{"src":"https:\u002F\u002Fdynamic.criteo.com\u002Fjs\u002Fld\u002Fld.js?a=116414","async":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-PF7MP5ZS')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"__dangerouslyDisableSanitizers":["script"],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-PF7MP5ZS&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_06752ca1 === 'function') {
    await nuxt_plugin_plugin_06752ca1(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsdynamic7567e1f4_10ddd10b === 'function') {
    await nuxt_plugin_pluginsdynamic7567e1f4_10ddd10b(app.context, inject)
  }

  if (typeof nuxt_plugin_vlazyload_897ace36 === 'function') {
    await nuxt_plugin_vlazyload_897ace36(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_35e8bc38 === 'function') {
    await nuxt_plugin_pluginutils_35e8bc38(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_f2a973a2 === 'function') {
    await nuxt_plugin_pluginrouting_f2a973a2(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_7993eba0 === 'function') {
    await nuxt_plugin_pluginmain_7993eba0(app.context, inject)
  }

  if (typeof nuxt_plugin_vsanitize_39ff2f3e === 'function') {
    await nuxt_plugin_vsanitize_39ff2f3e(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_58a0c7b4 === 'function') {
    await nuxt_plugin_recaptcha_58a0c7b4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clipboard_2297f117 === 'function') {
    await nuxt_plugin_clipboard_2297f117(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_45848137 === 'function') {
    await nuxt_plugin_axios_45848137(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_1fdad2df === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_1fdad2df(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_9f5bac66 === 'function') {
    await nuxt_plugin_gtm_9f5bac66(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_26821c7c === 'function') {
    await nuxt_plugin_deviceplugin_26821c7c(app.context, inject)
  }

  if (typeof nuxt_plugin_elementui_72a9ed1c === 'function') {
    await nuxt_plugin_elementui_72a9ed1c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_daisoui_2ab2214a === 'function') {
    await nuxt_plugin_daisoui_2ab2214a(app.context, inject)
  }

  if (typeof nuxt_plugin_validation_07995594 === 'function') {
    await nuxt_plugin_validation_07995594(app.context, inject)
  }

  if (typeof nuxt_plugin_vuexhelper_7179a606 === 'function') {
    await nuxt_plugin_vuexhelper_7179a606(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_persistedStateclient_3b127e9c === 'function') {
    await nuxt_plugin_persistedStateclient_3b127e9c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_tuigridclient_05051286 === 'function') {
    await nuxt_plugin_tuigridclient_05051286(app.context, inject)
  }

  if (typeof nuxt_plugin_axiosbuilder_287671a0 === 'function') {
    await nuxt_plugin_axiosbuilder_287671a0(app.context, inject)
  }

  if (typeof nuxt_plugin_axiosbuildercache_9984496a === 'function') {
    await nuxt_plugin_axiosbuildercache_9984496a(app.context, inject)
  }

  if (typeof nuxt_plugin_axiosbuilderpostcache_6b71e76c === 'function') {
    await nuxt_plugin_axiosbuilderpostcache_6b71e76c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_quilleditor_13127b74 === 'function') {
    await nuxt_plugin_quilleditor_13127b74(app.context, inject)
  }

  if (typeof nuxt_plugin_lodash_3538f289 === 'function') {
    await nuxt_plugin_lodash_3538f289(app.context, inject)
  }

  if (typeof nuxt_plugin_axiosserver_51445a30 === 'function') {
    await nuxt_plugin_axiosserver_51445a30(app.context, inject)
  }

  if (typeof nuxt_plugin_axiosdefaults_d30747cc === 'function') {
    await nuxt_plugin_axiosdefaults_d30747cc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_index_a3af4526 === 'function') {
    await nuxt_plugin_index_a3af4526(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_swiper_076f49ea === 'function') {
    await nuxt_plugin_swiper_076f49ea(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vcalendar_55bbb5ae === 'function') {
    await nuxt_plugin_vcalendar_55bbb5ae(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_videoplayer_cd2faf62 === 'function') {
    await nuxt_plugin_videoplayer_cd2faf62(app.context, inject)
  }

  if (typeof nuxt_plugin_globalcomponent_209c3683 === 'function') {
    await nuxt_plugin_globalcomponent_209c3683(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_kakao_25921bca === 'function') {
    await nuxt_plugin_kakao_25921bca(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_airbridge_e2bb1b8c === 'function') {
    await nuxt_plugin_airbridge_e2bb1b8c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueqrcode_035b36ae === 'function') {
    await nuxt_plugin_vueqrcode_035b36ae(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_groobeeResponse_8c404216 === 'function') {
    await nuxt_plugin_groobeeResponse_8c404216(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_route_192d86f8 === 'function') {
    await nuxt_plugin_route_192d86f8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_commonMsgbox_0c37c434 === 'function') {
    await nuxt_plugin_commonMsgbox_0c37c434(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuestyledcomponents_c7c73b56 === 'function') {
    await nuxt_plugin_vuestyledcomponents_c7c73b56(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_initzzimclient_a40e072e === 'function') {
    await nuxt_plugin_initzzimclient_a40e072e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_initancclient_771e4c2d === 'function') {
    await nuxt_plugin_initancclient_771e4c2d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_initbrandzzimclient_62ffc62f === 'function') {
    await nuxt_plugin_initbrandzzimclient_62ffc62f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_blux_34356b98 === 'function') {
    await nuxt_plugin_blux_34356b98(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clicktrackerclient_7a1445db === 'function') {
    await nuxt_plugin_clicktrackerclient_7a1445db(app.context, inject)
  }

  if (typeof nuxt_plugin_jsonld_593ee954 === 'function') {
    await nuxt_plugin_jsonld_593ee954(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
